"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _concat = _interopRequireDefault(require("lodash/concat"));
var _findIndex = _interopRequireDefault(require("lodash/findIndex"));
var _max = _interopRequireDefault(require("lodash/max"));
var _reactSlick = _interopRequireDefault(require("react-slick"));
var _constant = require("../../../../../constant");
var _ = require("../../../..");
var _utils = require("../../../../../utils");
var _styled = require("../../../../buttons/close-button/styled");
var _styled2 = require("../../../../buttons/custom-button/styled");
var _contentSlide = _interopRequireDefault(require("./content-slide"));
var _styled3 = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ExperienceSlider = function ExperienceSlider(_ref) {
  var onClose = _ref.onClose,
    student = _ref.student,
    goToMyResume = _ref.goToMyResume,
    showModal = _ref.showModal,
    modalParams = _ref.modalParams,
    showProfile = _ref.showProfile,
    hasHighlight = _ref.hasHighlight;
  var experiences = student && (0, _concat.default)(student.professionalExperiences.filter(function (professionalExperience) {
    return professionalExperience.activeLines === 1;
  }), student.otherExperiences.filter(function (otherExperience) {
    return otherExperience.activeLines === 1;
  }));
  var indexCompany = (0, _findIndex.default)(experiences, function (e) {
    return e.company === modalParams;
  });
  var indexGroup = (0, _findIndex.default)(experiences, function (e) {
    return e.group === modalParams;
  });
  var initialSlide = (0, _max.default)([indexCompany, indexGroup, 0]);
  return /*#__PURE__*/_react.default.createElement(_.CustomModal, {
    isActive: showModal === 'experience',
    fullPage: true,
    experience: modalParams
  }, /*#__PURE__*/_react.default.createElement(_styled3.Container, {
    id: "modalExperience"
  }, /*#__PURE__*/_react.default.createElement(_styled3.WrapperTitle, null, /*#__PURE__*/_react.default.createElement(_styled3.Title, null, "Experience"), /*#__PURE__*/_react.default.createElement(_styled.CloseButton, {
    onClick: onClose
  })), /*#__PURE__*/_react.default.createElement(_styled3.WrapperSlider, null, /*#__PURE__*/_react.default.createElement(_styled2.CustomButton, {
    color: _constant.colors.VIOLET,
    className: "btn-resume",
    onClick: goToMyResume
  }, "resume pdf"), student && /*#__PURE__*/_react.default.createElement(_reactSlick.default, _extends({}, _constant.sliderSettings, {
    initialSlide: initialSlide
  }), experiences.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_contentSlide.default, {
      key: item.id,
      content: item,
      showProfile: showProfile,
      hasHighlight: hasHighlight
    });
  })))));
};
ExperienceSlider.propTypes = {
  onClose: _propTypes.default.func.isRequired,
  goToMyResume: _propTypes.default.func.isRequired,
  student: _utils.studentProps,
  showModal: _propTypes.default.string,
  showProfile: _propTypes.default.bool,
  hasHighlight: _propTypes.default.bool,
  modalParams: _propTypes.default.string
};
ExperienceSlider.defaultProps = {
  showModal: null,
  showProfile: null,
  modalParams: '',
  hasHighlight: false,
  student: {
    otherExperiences: [],
    professionalExperiences: []
  }
};
var _default = ExperienceSlider;
exports.default = _default;